import { useDropzone } from 'react-dropzone';
import { DropFiles } from '../../modules/end-user/create-your-assistant/data/constants';
import { FileUploaderFile, FileUploaderProps } from './file-uploder';
import { UploadCloudIcon } from '../../assets/images';

function FileUploader({
  multiple,
  accept,
  maxFiles = multiple ? 5 : 1,
  onFilesAccepted,
  onFileRejected,
  disabled,
  className,
  triggerId,
  children,
  supportedFormats,
  backgroundColor,
  height = '80px',
  enableUploadCloudIcon,
}: FileUploaderProps) {
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    multiple,
    maxFiles,
    disabled,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        onFileRejected?.({
          fileName: fileRejections[0].file.name,
          reason: 'Unsupported format or exceeds limit',
        });
        return;
      }
      if (multiple) {
        onFilesAccepted(acceptedFiles as File[]);
        return;
      }
      const readPromises = acceptedFiles?.map(
        (file) =>
          new Promise<FileUploaderFile>((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              resolve({
                name: file.name,
                size: file.size,
                type: file.type,
                data: reader.result,
              });
            };
          }),
      );
      Promise.all(readPromises).then(onFilesAccepted);
      // onFilesAccepted(acceptedFiles);
    },
  });

  return (
    <div
      className={`${disabled ? 'opacity-50' : ''} ${className}`}
      {...getRootProps({ onClick: (e) => e.stopPropagation() })}
    >
      <input {...getInputProps()} type="file" id={triggerId} className="hidden" />
      {children || (
        <div
          className={`border-2 border-dashed border-gray-400 p-4 rounded-md text-center flex flex-col justify-center items-center ${
            backgroundColor ? `bg-[${backgroundColor}]` : 'bg-white'
          }`}
          style={{ minHeight: `${height}` }}
        >
          {enableUploadCloudIcon && <img src={UploadCloudIcon} alt="upload" />}
          <h2 className="text-[1.25rem] font-bold">
            {DropFiles}{' '}
            <span
              className="text-[#0A8BC7] underline cursor-pointer"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                (document.querySelector(`#${triggerId}`) as HTMLInputElement)?.click();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  (document.querySelector(`#${triggerId}`) as HTMLInputElement)?.click();
                }
              }}
            >
              Browse
            </span>
          </h2>
          {supportedFormats && <p className="text-sm text-gray-600">{supportedFormats}</p>}
        </div>
      )}
    </div>
  );
}

export default FileUploader;
